/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';
import { BriefDetails_StructuredBriefFragment } from '../components/BriefDetailsList.generated';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type BriefEntryQueryVariables = Types.Exact<{
    id?: Types.Maybe<Types.Scalars['Int']>;
}>;

export type BriefEntryQuery = {
    __typename: 'Query';
    me: {
        __typename: 'Viewer';
        user: Types.Maybe<{ __typename: 'User' } & BriefEntry_UserFragment>;
    };
    designer: Types.Maybe<{
        __typename: 'User';
        id: string;
        displayName: string;
        profile: { __typename: 'CreatorHit'; certifications: Array<string> };
    }>;
    drafts: Array<{ __typename: 'StructuredBrief' } & BriefDetails_StructuredBriefFragment>;
    launched: Array<{ __typename: 'StructuredBrief' } & BriefDetails_StructuredBriefFragment>;
};

export type BriefEntry_UserFragment = { __typename: 'User'; id: string; displayName: string };

export const BriefEntry_UserFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BriefEntry_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                ],
            },
        },
    ],
};
export const BriefEntryDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'BriefEntry' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'me' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'BriefEntry_User' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designer' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'profile' },
                                    name: { kind: 'Name', value: 'createProfile' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'certifications' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'drafts' },
                        name: { kind: 'Name', value: 'recentDraftStructuredBriefs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '10' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'BriefDetails_StructuredBrief' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'launched' },
                        name: { kind: 'Name', value: 'recentLaunchedStructuredBriefs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'IntValue', value: '10' },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'BriefDetails_StructuredBrief' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BriefEntry_User' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BriefDetails_StructuredBrief' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StructuredBrief' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designers' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'requiresCertifications' } },
                ],
            },
        },
    ],
};
export type BriefEntryComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<BriefEntryQuery, BriefEntryQueryVariables>,
    'query'
>;

export const BriefEntryComponent = (props: BriefEntryComponentProps) => (
    <ApolloReactComponents.Query<BriefEntryQuery, BriefEntryQueryVariables>
        query={BriefEntryDocument}
        {...props}
    />
);

/**
 * __useBriefEntryQuery__
 *
 * To run a query within a React component, call `useBriefEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefEntryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefEntryQuery(
    baseOptions?: Apollo.QueryHookOptions<BriefEntryQuery, BriefEntryQueryVariables>
) {
    return Apollo.useQuery<BriefEntryQuery, BriefEntryQueryVariables>(
        BriefEntryDocument,
        baseOptions
    );
}
export function useBriefEntryLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<BriefEntryQuery, BriefEntryQueryVariables>
) {
    return Apollo.useLazyQuery<BriefEntryQuery, BriefEntryQueryVariables>(
        BriefEntryDocument,
        baseOptions
    );
}
export type BriefEntryQueryHookResult = ReturnType<typeof useBriefEntryQuery>;
export type BriefEntryLazyQueryHookResult = ReturnType<typeof useBriefEntryLazyQuery>;
export type BriefEntryQueryResult = Apollo.QueryResult<BriefEntryQuery, BriefEntryQueryVariables>;
